<div class="main">
  <p *ngIf="withTitle">{{title}}</p>
  <app-property-doc-card *ngIf="document; else addDoc" class="d-flex col-md-6 col-lg-4" [prop]="prop" [title]="title"
    [lightMode]="true" [docs]="[document]" (docUpdated)="onDocUpdated()" (docDeleted)="onDocDeleted($event)"
    (docDeleted)="onDocDeleted($event)"></app-property-doc-card>
  <ng-template #addDoc>
    <div class="choose">
      <div *ngIf="withType && !type">
        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select placeholder="" required [(value)]="typeSelected">
            <mat-option *ngFor="let docType of availableDocTypes" [value]="docType">
              {{ 'enum.DocumentType.'+docType | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <app-file-upload (userWantsUploadEvent)="onUserWantsUploadEvent($event)"
        (hasSelectedFile)="onUploadSelectedFile($event)" text="uploadFile.chooseFile" uploadText="uploadFile.uploadFile"
        [backendResponse]="backendResponseUploadedFile" [isLoading]="isLoadingUpload" [width]="80" [height]="80">
      </app-file-upload>
      <button *ngIf="withSelect && !uploadDocSelected" mat-flat-button extended color="primary"
        (click)="openSelectDocument()" appTooltip="Selectionn un document existant">
        <mat-icon>task</mat-icon>
        {{'selectDoc' | translate}}
      </button>
    </div>
  </ng-template>
  <ng-template #upload>
  </ng-template>
</div>